import { PARTNERS } from "../data/partners";
import Breadcrumbs from "./Breadcrumbs";
import SectionHeading from "./SectionHeading";
import { useLanguage } from "../context/LanguageContext";

export default function BrandsPage() {
  const { t } = useLanguage();
  return (
    <section className="bg-white pb-24 pt-24 md:pb-32 md:pt-32">
      <Breadcrumbs items={[{ label: t("brandsTitle") }]} />
      <div className="container-industrial pt-16">
        <SectionHeading title={t("brandsTitle")} description={t("brandsDescription")} />

        <div className="mt-16 grid grid-cols-2 gap-px border border-steel-200 bg-steel-200 sm:grid-cols-3 lg:grid-cols-4">
          {PARTNERS.map(({ name, file }) => (
            <div
              key={file}
              className="flex h-32 items-center justify-center bg-white p-6 transition-colors duration-200 ease-engineered hover:bg-steel-50"
            >
              <img
                src={`/assets/brand/partners/${file}.svg`}
                alt={name}
                title={name}
                draggable={false}
                className="h-full w-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
